import React, { useState, useRef, useEffect } from "react";
import {
  MdOutlineAddAPhoto,
} from "react-icons/md";
import { useSelector } from "react-redux";
import Modal, { LocationModal } from "../UI/Modal";
import { AnimatePresence, motion } from "framer-motion";
import Button from "../UI/Button";
import ModalMultiple from "../UI/ModalMultiple";
import ImageCarousel from "../UI/Carousel";
import Map from "../components/Map";
import { PiYoutubeLogo } from "react-icons/pi";
import { MdAddCircleOutline } from "react-icons/md";
import { IoImagesOutline, IoLocationOutline } from "react-icons/io5";
import Input, { RadioButtonGroup, RadioInput } from "../UI/Input";
import { HiOutlineTrash } from "react-icons/hi2";
import { useMediaQuery } from "react-responsive";
import Select from "react-select"; import { LuMapPin, LuPenSquare } from "react-icons/lu";
import { createPortal } from "react-dom";
;

const LinkInput = ({
  register,
  errors,
  index,
  formData,
  setFormData,
  storedFormData,
}) => {
  const handleChange = (evt) => {
    const link = evt.target?.value;
    formData.meeting_link = link;
    setFormData(formData);
  };

  return (
    <div className="flex flex-col gap-0 mt-2">
      <Input
        placeholder="Link to the meeting"
        type="text"
        classes="w-[100%]"
        // required={true}
        name={`meetlink`}
        handleChange={handleChange}
        defaultValue={
          storedFormData?.meeting_link ? storedFormData?.meeting_link : null
        }
      ></Input>
      {/* <SecondaryButton text="Remove" handleClick={()=>{removeLinkInput(index)}}></SecondaryButton> */}
    </div>
  );
};


const timeOptions = [
  { value: "multiday", label: "Multi-day" },
  { value: "hourly", label: "Hourly" },
];


const MediaForm = ({
  errors,
  register,
  formDataFiles,
  setFormDataFiles,
  formData,
  setFormData,
  cityOptions,
}) => {
  const [clicked, setClicked] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [value, setValue] = useState("");
  const [coverImage, setCoverImage] = useState({});
  const [selectedCities, setSelectedCities] = useState([]);
  const [coverVideo, setCoverVideo] = useState({});
  const [eventImages, setEventImages] = useState([]);
  const [isMultipleUpload, setIsMultipleUpload] = useState(false);
  const [location, setLocation] = useState("offline");
  const [addLocationClicked, setAddLocationClicked] = useState(false);
  const [offlineLocation, setOfflineLocation] = useState(null);
  const [latlng, setLatlng] = useState({});
  const [shortLocation, setShortLocation] = useState(null);
  const [isHourlyEvent, setIsHourlyEvent] = useState(false);
  const [placeID, setPlaceID] = useState(null)
  const storedFormData = useSelector((state) => state.formData);
  const [days, setDays] = useState(storedFormData.number_of_days || 0);
  const [nights, setNights] = useState(storedFormData.number_of_nights || 0);
  const [hours, setHours] = useState(storedFormData.number_of_hours || 0);
  const [link_howToReach, setLinkHowToReach] = useState(null)
  const [linesError, setLinesError] = useState(false);
  const [googleCity, setGoogleCity] = useState(null);

  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  const storedFormFiles = useSelector((state) => state.formDataFiles);

  const eventSlug = useSelector((state) => state.eventSlug);
  const companyname = useSelector((state) => state.companyname);

  const [googleContainer, setGoogleContainer] = useState(null);

  const [showPortal, setShowPortal] = useState(false);

  // useEffect(() => {
  //   console.log(addLocationClicked, placeID, location, companyname, googleContainer)
  //   if (
  //     addLocationClicked &&
  //     placeID &&
  //     location === "offline" &&
  //     (companyname === "trove-experiences" || companyname === "logoutworld") &&
  //     googleContainer
  //   ) {
  //     setShowPortal(true);
  //   }
  // }, [addLocationClicked, placeID, googleContainer, location, companyname]);

  useEffect(() => {
    if (addLocationClicked) {
      const el = document.getElementById("google-link-container");
      setGoogleContainer(el);
    }
  }, [addLocationClicked]);



  const saveGoogleLocation = (placeId) => {
    setFormData((prev) => { return { ...prev, google_location_place_id: placeId } });
  }

  useEffect(() => {
    setFormData((prevData) => {
      return {
        ...prevData,
        number_of_days: days,
        number_of_nights: nights,
        number_of_hours: hours,
      };
    });
  }, [days, nights, hours]);



  useEffect(() => {
    if (shortLocation)
      setFormData((prev) => { return { ...prev, event_location: shortLocation } })
  }, [shortLocation])

  useEffect(() => {
    if (latlng && Object.keys(latlng).length > 0)
      setFormData((prev) => { return { ...prev, google_location_latitude: latlng.lat, google_location_longitude: latlng.lng } })
  }, [latlng])

  useEffect(() => {
    if (storedFormFiles && Object.keys(storedFormFiles).length > 0) {
      if (storedFormFiles.coverImage && Object.keys(storedFormFiles.coverImage).length > 0) {
        // console.log("here",storedFormFiles.coverImage.preview.startsWith("https" || "blob"))
        if (
          storedFormFiles.coverImage.preview.startsWith("https") ||
          storedFormFiles.coverImage.preview.startsWith("blob")
        ) {
          setCoverImage(storedFormFiles.coverImage);
        } else {
          const image = { ...storedFormFiles.coverImage };
          image.preview = `${process.env.REACT_APP_API_URL}` + image.preview;
          setCoverImage(image);
        }
      }

      if (storedFormFiles.coverVideo && Object.keys(storedFormFiles.coverVideo).length > 0) {
        setCoverVideo(storedFormFiles.coverVideo);
        // console.log("here",storedFormFiles.coverVideo)
        if (storedFormFiles?.coverVideo?.preview != null) {
          if (
            storedFormFiles?.coverVideo?.preview?.startsWith("https") ||
            storedFormFiles?.coverVideo?.preview?.startsWith("blob")
          ) {
            setCoverVideo(storedFormFiles.coverVideo);
          } else {
            const video = { ...storedFormFiles.coverVideo };
            video.preview = `${process.env.REACT_APP_API_URL}` + video.preview;
            setCoverVideo(video);
          }
        }
      }
      if (storedFormFiles.eventImages && storedFormFiles.eventImages.length > 0) {
        setEventImages(storedFormFiles.eventImages);

      }
    }
  }, [storedFormFiles]);

  const handleAddClickCities = (options) => {
    console.log(options)
    let selOptions = [options]
    const selected = []
    selOptions.map((option) => {
      selected.push(option.label)
    })
    setSelectedCities(options);
    setFormData((prevData) => ({ ...prevData, cities: selected }));
  };


  const textAreaRef = useRef(null);
  const locationOptions = [
    { value: "offline", label: "Offline" },
    { value: "online", label: "Online" },
  ];

  const [meetlink, setMeetLink] = useState("");

  useEffect(() => {
    if (storedFormData?.meeting_link) {
      setMeetLink(storedFormData.meeting_link);
    }
    if (storedFormData?.name) {
      setValue(storedFormData.name);
      // adjustHeight();
    }

    if (storedFormData?.city?.length > 0) {
      var selCities = []
      storedFormData?.city?.forEach((rep) => {
        const res = cityOptions.filter((city) => city.label == rep);
        if (res) {
          selCities.push(res[0])
        }
        setFormData((prev) => { return { ...prev, cities: storedFormData?.city } })
      });
      setSelectedCities(selCities);
    }
  }, [storedFormData]);


  useEffect(() => {
    if (coverImage?.preview) {
      setFormDataFiles({ ...formDataFiles, coverImage: coverImage });
    }
  }, [coverImage]);

  useEffect(() => {
    if (offlineLocation) {
      setFormData((prev) => { return { ...prev, google_location_display_name: offlineLocation } });
    }
  }, [offlineLocation]);

  useEffect(() => {
    if (googleCity) {
      const selCity = cityOptions.find((city) => city.label === googleCity);
      if (selCity) handleAddClickCities(selCity)
    }
  }, [googleCity])

  useEffect(() => {
    if (coverVideo?.preview)
      setFormDataFiles({ ...formDataFiles, coverVideo: coverVideo });
  }, [coverVideo]);


  useEffect(() => {
    if (eventImages.length > 0) {
      setFormDataFiles({ ...formDataFiles, eventImages: eventImages });
    }
  }, [eventImages]);

  const handleLocChange = (value) => {
    console.log('offline', value)
    setLocation(value);
    setFormData((prev) => { return { ...prev, event_type: value == "offline" ? "true" : "false" } });
  };

  useEffect(() => {
    setFormData((prev) => { return { ...prev, event_type: "true" } })
  }, [])


  const openModal = (title) => {
    setModalTitle(title);
    setClicked(true);
  };

  const closeModal = () => {
    setClicked(false);
    setIsMultipleUpload(false);
  };

  const handleChange = (evt) => {
    setValue(evt.target.value);
    setFormData((prev) => { return { ...prev, name: evt.target.value } });
  };

  useEffect(() => {
    setFormData((prev) => {
      return {
        ...prev,
        'link_howToReach': link_howToReach
      }
    })
  }, [link_howToReach])

  const removeEventImage = (id) => {
    setEventImages(eventImages.filter((image) => image.id !== id));
    setFormDataFiles({
      ...formDataFiles,
      eventImages: eventImages.filter((image) => image.id !== id),
    })
    if (eventSlug) {
      const updatedDeletedPhotos = formDataFiles.deletedPhotos && [...formDataFiles.deletedPhotos];
      if (!updatedDeletedPhotos.includes(id)) {
        updatedDeletedPhotos.push(id); // Add the photo URL
      } else {
        console.log("This item already exists");
      }
      setFormDataFiles({
        ...formDataFiles,
        deletedPhotos: updatedDeletedPhotos,
      });
    }
  };

  useEffect(() => {
    if (placeID) {
      console.log("Place ID:", placeID);
      console.log(`https://www.google.com/maps/place/?q=place_id:${placeID}`)
      setFormData((prev) => { return { ...prev, google_location_place_id: placeID } })
    }
  }, [placeID])

  console.log(formData)

  useEffect(() => {
    if (storedFormData && Object.keys(storedFormData).length > 0) {
      setDays(storedFormData.number_of_days || 0);
      setNights(storedFormData.number_of_nights || 0);
      setHours(storedFormData.number_of_hours || 0);
      if (storedFormData.google_location_place_id) {
        setPlaceID(storedFormData.google_location_place_id)
        // saveGoogleLocation(storedFormData.google_location_place_id)
      }
      if (storedFormData.link_howToReach) {
        setLinkHowToReach(storedFormData.link_howToReach)
      }
      if (storedFormData.About_Place) {
        setFormData((prev) => ({
          ...prev,
          About_Place: storedFormData.About_Place
        }))
      }
      // if (storedFormData.About_Place) {
      //   setLinkHowToReach(storedFormData.)
      // }
      if (storedFormData.event_type) {
        setLocation(storedFormData.event_type ? "offline" : "online");

        if (storedFormData.event_type) {

          if (storedFormData.event_location != null) {
            setShortLocation(storedFormData.event_location);
          }
          if (storedFormData.google_location_display_name != null) {

            setOfflineLocation(storedFormData.google_location_display_name);
          }
        }
      }
      if (
        (storedFormData.number_of_days == null || storedFormData.number_of_days === 0) &&
        (storedFormData.number_of_nights == null || storedFormData.number_of_nights === 0) &&
        storedFormData.number_of_hours
      ) {
        setIsHourlyEvent(true);
      }
    }
  }, [storedFormData]);

  return (
    <AnimatePresence>
      <motion.div
        className=""
        initial={{ opacity: 0, y: 0 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0 }}
        transition={{ opacity: { duration: 0.75 }, y: { duration: 0.5 } }}
      >
        <img
          src="https://logout.world/static/dashboard_studio/media/illustrations/sigma-1/17.png"
          alt="image"
          className="w-40 h-40 m-auto mt-4"
        />
        <div className="grid xl:grid-cols-1 grid-cols-1 gap-8 px-6 py-4 pb-24">
          <div className="flex flex-col section_gap_sm lg:section_gap_lg">
            <div className="grid grid-rows-1 lg:grid-cols-3 mt-6">
              <h2 className="section_heading">
                Event name*
              </h2>
              <div className="col-span-2">
                <input
                  type="text"
                  style={{ fontSize: "1rem" }}
                  placeholder="Event Name"
                  autoFocus
                  defaultValue={storedFormData?.name}
                  onChange={handleChange}
                  required
                  // ref={textAreaRef}
                  className=" bg-[#f8f6f2] w-full rounded-xl px-[1.5rem] py-[0.65rem] focus:bg-[#f4f1eb] font-medium outline-none border-none text-black focus:outline-none placeholder-gray-400"
                />
              </div>
            </div>
            <div className="grid grid-rows-1 lg:grid-cols-3 grid-cols-1">
              <h2 className="section_heading">
                Cover Image*
              </h2>
              {!coverImage?.preview ? (
                <div className="bg-white col-span-2 relative rounded-xl border-2 border-[#dad3c3] border-dashed py-10 flex flex-col justify-center items-center gap-2">
                  <MdOutlineAddAPhoto size={35} className="" />
                  <Button handleClick={() => openModal("Choose cover image")} text={'Add cover image'} />

                  <input
                    type="file"
                    value={coverImage?.preview}
                    required
                    accept="image/png, image/jpeg"
                    className="opacity-0 left-10 absolute top-20 pointer-events-none"
                  />
                </div>
              ) : (
                <div className="">
                  <div
                    style={{
                      backgroundImage: `url(${coverImage.preview})`,
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                      paddingBottom: "66.67%",
                      borderRadius: "0.75rem",
                      aspectRatio: "1/1",
                    }}
                    className={`relative overflow-hidden`}
                  ></div>
                  <div
                    onClick={() => {
                      setCoverImage(null);
                    }}
                    className="flex justify-self-end mt-2 text-sm text-black items-center gap-1 px-2 py-1 rounded-md cursor-pointer"
                  >
                    <span>Remove</span>
                    <HiOutlineTrash size={20} />
                  </div>
                </div>
              )}
            </div>
            <div className="grid grid-rows-1 lg:grid-cols-3 grid-cols-1">
              <h2 className="section_heading">
                Cover Video
              </h2>
              {!coverVideo?.preview ? (
                isMobile ? (
                  <div
                    className="bg-[#f8f6f2] flex justify-between items-center px-4 py-2 rounded-xl"
                    onClick={() => openModal("Choose cover video")}
                  >
                    <div className="flex items-center gap-3 cursor-pointer">
                      <PiYoutubeLogo size={25} />
                      <span className="font-semibold">Add cover video</span>
                    </div>
                    <MdAddCircleOutline
                      size={25}
                      className=" text-gray-500 cursor-pointer"
                    />
                  </div>
                ) : (
                  <div className="bg-white col-span-2 relative rounded-xl border-2 border-[#dad3c3] border-dashed py-10 flex flex-col justify-center items-center gap-2">
                    <MdOutlineAddAPhoto size={35} className="" />
                    {/* <button
                      type="button"
                      className="text-white relative bg-[#4F55DA] font-medium px-4 py-1 my-0 rounded-lg"
                      onClick={() => openModal("Choose cover video")}
                    >
                      Add cover video
                    </button> */}
                    <Button text={'Add cover video'} handleClick={() => openModal("Choose cover video")} />
                    <input
                      type="file"
                      value={coverVideo?.preview}
                      className="opacity-0 left-10 absolute top-20 pointer-events-none"
                    />
                  </div>
                )
              ) : (
                <div className={`relative overflow-hidden`}>
                  <video width="400" controls style={{ borderRadius: '0.75rem' }}>
                    <source src={coverVideo?.preview} />
                  </video>
                  <div
                    onClick={() => {
                      setCoverVideo(null);
                    }}
                    className="flex justify-self-end mt-2 text-sm text-black items-center gap-1 px-2 py-1 rounded-md cursor-pointer"
                  >
                    <span>Remove</span>
                    <HiOutlineTrash size={20} />
                  </div>
                  {/* <img src={URL.createObjectURL(coverImage)} alt='cover' className='absolute object-cover w-full top-0 left-0'/> */}
                </div>
              )}
            </div>
            <div className="lg:hidden">
              <h2 className="section_heading lg:hidden">Event Images</h2>
              {eventImages.length > 0 && (
                <div className="lg:hidden">
                  <ImageCarousel
                    className="lg:hidden"
                    removeEventImage={removeEventImage}
                    images={eventImages}
                  />
                </div>
              )}

              <div
                className={`bg-[#f8f6f2] lg:hidden flex justify-between items-center px-4 py-2 ${eventImages.length > 0 ? 'mt-3' : 'mt-2'} rounded-xl`}
                onClick={() => {
                  setIsMultipleUpload(true);
                }}
              >
                <div className="flex items-center gap-3 cursor-pointer">
                  <IoImagesOutline size={25} />
                  <span className="font-semibold">Add images</span>
                </div>
                <MdAddCircleOutline
                  size={25}
                  className=" text-gray-500 cursor-pointer"
                />
              </div>
            </div>
            <div className="grid-cols-3 grid-rows-1 hidden lg:grid">
              <h2 className="section_heading">Event Images</h2>
              {eventImages.length == 0 && (
                <div className="bg-white hidden col-span-2 lg:flex relative rounded-xl border-2 border-[#dad3c3] border-dashed py-10 flex-col justify-center items-center gap-2">
                  <MdOutlineAddAPhoto size={35} className="" />
                  <Button handleClick={() => setIsMultipleUpload(true)} text={'Add event images'} />
                </div>
              )}
              {eventImages.length > 0 && (
                <div className="flex-col hidden lg:flex">
                  <ImageCarousel
                    removeEventImage={removeEventImage}
                    images={eventImages}
                  />
                  <div
                    className="bg-[#f8f6f2] flex justify-between items-center px-4 py-2 rounded-xl mt-4"
                    onClick={() => {
                      setIsMultipleUpload(true);
                    }}
                  >
                    <div className="flex items-center gap-3 cursor-pointer">
                      <IoImagesOutline size={25} />
                      <span className="font-semibold">Add images</span>
                    </div>
                    <MdAddCircleOutline
                      size={25}
                      className=" text-gray-500 cursor-pointer"
                    />
                  </div>
                </div>
              )}
            </div>

            <div className="py-4 mt-0 lg:mt-0 lg:section_padding_lg align-baseline grid grid-rows-1 lg:grid-cols-3">
              <h2 className="section_heading mb-2 lg:mb-0">Duration*</h2>
              <div className="flex flex-col w-full col-span-2">
                <div className="pb-3">
                  <RadioButtonGroup
                    columns={2}
                    options={timeOptions}
                    selectedValue={isHourlyEvent ? "hourly" : "multiday"}
                    onChange={(value) => {
                      value == "hourly"
                        ? setIsHourlyEvent(true)
                        : setIsHourlyEvent(false);
                    }}
                  />
                </div>
                <div className="flex flex-col lg:flex-row w-full gap-2 pt-2">
                  <div className={`basis-full ${isHourlyEvent ? "hidden" : ""}`}>
                    <label className="text-sm input_label_padding  font-medium">
                      Day(s)
                    </label>
                    <Input
                      placeholder="Day(s)"
                      type="number"
                      handleChange={(e) => {
                        setDays(e.target.value);
                      }}
                      value={days != 0 ? days : ''}
                      classes={"w-full"}
                    />
                  </div>
                  <div className={`basis-full ${isHourlyEvent ? "hidden" : ""}`}>
                    <label className="text-sm input_label_padding  font-medium">
                      Night(s)
                    </label>
                    <Input
                      placeholder="Night(s)"
                      type="number"
                      handleChange={(e) => {
                        setNights(e.target.value);
                      }}
                      value={nights != 0 ? nights : ''}
                      classes={"w-full"}
                    />
                  </div>

                  <div
                    className={`${isHourlyEvent ? "lg:w-[50%] col-span-1" : "basis-full "
                      }`}
                  >
                    <label className="text-sm input_label_padding  font-medium">
                      Hour(s)
                    </label>
                    <Input
                      placeholder="Hour(s)"
                      type="number"
                      handleChange={(e) => {
                        setHours(e.target.value);
                      }}
                      value={hours != 0 ? hours : ''}
                      classes={"w-full"}
                      required={isHourlyEvent}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="grid lg:grid-cols-3 grid-rows-1">
              <h2 className="section_heading">Location</h2>
              <div className="flex flex-col col-span-2">
                <div class="space-x-4">
                  <RadioButtonGroup
                    columns={2}
                    options={locationOptions}
                    selectedValue={location}
                    onChange={(value) => handleLocChange(value)}
                    name="location"
                  />
                </div>


                {location == "online" && (
                  <div className="mt-3">
                    <h2 className="section_heading">Meeting link</h2>
                    <LinkInput
                      key={0}
                      register={register}
                      formData={formData}
                      setFormData={setFormData}
                      storedFormData={storedFormData}
                      meetlink={meetlink}
                      errors={errors}
                    />
                  </div>
                )}
              </div>
            </div>
            {location == "offline" && (<div className="grid lg:grid-cols-3 grid-rows-1">
              <h2 className="section_heading">Venue</h2>
              <div className="flex flex-col col-span-2">

                <div className="">
                  {/* <Input value={shortLocation} handleChange={(e)=>{setShortLocation(e.target.value)}} placeholder={"Location"} type="text" classes="w-full" /> */}
                  <div className="col-span-2">
                    {/* <Input defaultValue={shortLocation} classes={'w-full'} type={'text'} placeholder={'Enter Location'} handleChange={(e)=>{setShortLocation(e.target.value)}} /> */}
                    <textarea maxLength={50} className="w-full rounded-xl border-2 p-3 text-[13px] focus-visible:outline-none min-h-[100px]" placeholder="Enter Location" value={shortLocation} onChange={(e) => {
                      const lines = e.target.value.split("\n").length
                      if (lines > 3) {
                        setLinesError(true)
                        setTimeout(() => { setLinesError(false) }, 1500)
                        return;
                      }
                      setShortLocation(e.target.value)
                    }} />
                    {linesError && <span className="text-sm ml-2 text-red-500">Max. number of lines reached</span>}
                    {/* // <Editor defaultvalue={shortLocation} setValue={setShortLocation} /> */}
                  </div>
                </div>


              </div>
            </div>)}

            {location == "offline" && (<div className="grid lg:grid-cols-3 grid-rows-1">
              <h2 className="section_heading">Venue Facilities</h2>
              <div className="flex flex-col col-span-2">

                <div className="">
                  {/* <Input value={shortLocation} handleChange={(e)=>{setShortLocation(e.target.value)}} placeholder={"Location"} type="text" classes="w-full" /> */}
                  <div className="col-span-2">
                    {/* <Input defaultValue={shortLocation} classes={'w-full'} type={'text'} placeholder={'Enter Location'} handleChange={(e)=>{setShortLocation(e.target.value)}} /> */}
                    <textarea className="w-full rounded-xl border-2 p-3 text-[13px] focus-visible:outline-none min-h-[100px]" placeholder="Enter Facilities" value={formData['About_Place']} onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        About_Place: e.target.value
                      }))
                    }} />
                    {linesError && <span className="text-sm ml-2 text-red-500">Max. number of lines reached</span>}
                    {/* // <Editor defaultvalue={shortLocation} setValue={setShortLocation} /> */}
                  </div>
                </div>


              </div>
            </div>)}


            {location == 'offline' && <div className="grid lg:grid-cols-3 grid-rows-1 lg:mb-4">
              <h2 className="section_heading">Google Location</h2>
              <div className="flex flex-col col-span-2">


                {location == "offline" && (
                  <div>
                    {offlineLocation && offlineLocation != "undefined" && (
                      <div>
                        <div className="flex items-end justify-between pr-4">
                          <div>
                            <h2 className=" flex items-start gap-1 max-w-xl">
                              <LuMapPin className="shrink-0 mt-0.5" size={20} />
                              {formData.google_location_display_name && formData.google_location_display_name != "undefined" && <span className="ml-1 font-semibold">{formData.google_location_display_name}
                                <br></br>
                                {Array.isArray(formData?.cities) && formData?.cities?.length > 0 && (
                                  <div className="text-gray-500">{formData?.cities[0]}</div>
                                )}
                              </span>}

                            </h2>
                            {/* <div>
                              City: {googleCity}
                            </div> */}
                          </div>
                          <div onClick={() => {
                            setAddLocationClicked(true);
                          }} className="flex cursor-pointer items-center gap-1 text-[16px] underline">
                            <LuPenSquare size={14} />
                            Edit
                          </div>
                        </div>
                        <Map formData={formData} disabled={offlineLocation && offlineLocation != "undefined"} setAddLocationClicked={setAddLocationClicked} setSelectedLocation={setOfflineLocation} selectedLocation={offlineLocation} setPlaceId={setPlaceID} setLatlng={setLatlng} setGoogleCity={setGoogleCity} googleCity={googleCity} setLinkHowToReach={setLinkHowToReach} />
                      </div>
                    )}

                    {(!offlineLocation || offlineLocation == 'undefined') && <div
                      className={`bg-[#f8f6f2] flex justify-between cursor-pointer ${offlineLocation ? 'mt-3' : ''} items-center px-4 py-2 rounded-xl`}
                      onClick={() => {
                        setAddLocationClicked(true);
                      }}
                    >
                      <div className="flex items-center gap-3">
                        <IoLocationOutline size={25} />
                        <span className="font-semibold">
                          {offlineLocation ? "Update" : "Add"} location
                        </span>
                      </div>
                      <MdAddCircleOutline
                        size={25}
                        className=" text-gray-500 cursor-pointer"
                      />
                    </div>}
                  </div>
                )}

                {location == "online" && (
                  <div className="mt-3">
                    <h2 className="section_heading">Meeting link</h2>
                    <LinkInput
                      key={0}
                      register={register}
                      formData={formData}
                      setFormData={setFormData}
                      storedFormData={storedFormData}
                      meetlink={meetlink}
                      errors={errors}
                    />
                  </div>
                )}
              </div>

            </div>}

            {showPortal && googleContainer && (companyname === "trove-experiences" || companyname === "logoutworld") && (createPortal(<div className="grid mt-2 lg:grid-cols-1 grid-rows-1 lg:mb-4">
              <h2 className="text-base font-medium mb-2">Google Location Link</h2>
              <div className="col-span-2">
                <Input placeholder="Location Link"
                  type="text"
                  handleChange={(e) => {
                    setLinkHowToReach(e.target.value);

                  }}
                  // disabled
                  value={link_howToReach}
                  classes={"w-full"}
                // required={isHourlyEvent}
                />
              </div>
            </div>, googleContainer))}

            {/* {
              createPortal(<div className="grid grid-rows-1 lg:grid-cols-1 lg:my-4">
                <h2 className="section_heading">City</h2>
                {offlineLocation && <div className="col-span-2">
                  <Select
                    onChange={handleAddClickCities}
                    value={selectedCities}
                    isSearchable
                    // isDisabled
                    options={cityOptions}
                    styles={customStyles}
                    menuPlacement="top"
                    classNames={{
                      control: () => "!rounded-xl !border-2 !border-[#e5e7eb]",
                    }}
                  />
                </div>}
              </div>, document.getElementById('city-container'))
            } */}



          </div>
          <Modal
            isOpen={clicked}
            closeModal={closeModal}
            heading={modalTitle}
            setCoverImage={setCoverImage}
            setCoverVideo={setCoverVideo}
          />
          <ModalMultiple
            isOpen={isMultipleUpload}
            closeModal={closeModal}
            setEventImages={setEventImages}
            eventImages={eventImages}
          />
          {addLocationClicked && <LocationModal
            isOpen={addLocationClicked}
            closeModal={() => { setAddLocationClicked(false) }}
            setLocation={setOfflineLocation}
            offlineLocation={offlineLocation}
            saveGoogleLocation={saveGoogleLocation}
            setSelectedLocation={setOfflineLocation}
            selectedLocation={offlineLocation} setPlaceId={setPlaceID} setLatlng={setLatlng}
            setGoogleCity={setGoogleCity} googleCity={googleCity}
            setFormData={setFormData}
            handleAddClickCities={handleAddClickCities}
            selectedCities={selectedCities}
            cityOptions={cityOptions}
            setLinkHowToReach={setLinkHowToReach}
            formData={formData}
            setShowPortal={setShowPortal}
          />}

        </div>
      </motion.div>

    </AnimatePresence>
  );
};

export default MediaForm;

